interface PercentageBarProps {
  value: number | string;
}

export const PercentageBar = ({ value }: PercentageBarProps) => {
  const percentageValue = typeof value === 'string' ? parseFloat(value) : value;
  const definitelyANumber = isFinite(percentageValue) ? percentageValue : 0;
  const clampedPercentage = Math.max(0, Math.min(100, definitelyANumber));

  return (
    <div
      style={{
        width: '100%',
        backgroundColor: '#e0e0e0',
        borderRadius: '4px',
        border: '1px solid #76c7c0',
        position: 'relative',
      }}
    >
      <span
        style={{
          position: 'absolute',
          left: 5,
          fontSize: '12px',
          color: '#333',
        }}
      >
        {clampedPercentage.toFixed(0)}%
      </span>
      <div
        style={{
          width: `${clampedPercentage}%`,
          backgroundColor: '#76c7c0',
          height: '20px',
          borderRadius: '4px',
        }}
      />
    </div>
  );
};
